import React, { Component } from 'react';
//import {Alert} from 'react-bootstrap';
import { Jumbotron, Form, Col, Table, Button, Alert, Row } from 'react-bootstrap';
//import {Toast} from 'react-bootstrap';
// ;
import config from '../../../config';
import { IoIosRemoveCircle } from "react-icons/io";
import { IconContext } from "react-icons";
import funciones from '../../../middleware/funciones';
import Modalfactura from '../../subcomponent/modalFacturaAsociada';
import SearchClient from '../../subcomponent/searchClient';
import ModalConfirm from '../../subcomponent/modalConfirm';
import ModalImpresion from '../../subcomponent/modalImpresion';
//import { Header } from 'react-bootstrap/lib/Modal';

class Facturas extends Component {
    constructor(props) {
        const currentCompany = sessionStorage.getItem('company');
        const currentUserType = sessionStorage.getItem('tipo');
        const currentUser = sessionStorage.getItem('vendedor');
        super(props);
        this.state = {
            data: [],
            empresa: currentCompany,
            tipo: currentUserType,
            showAlert: false,
            numeroDocumento: 0,
            clientes: [],
            metodo_pago: [],
            retenciones: [],
            inventario: [],
            bodega: "",
            currentUser,
            PREFIJO: "",
            FORMA_PAGO: "",
            NUMERO_FACTURA: 0,
            CLIENTE: "",
            cod_lista: "",
            RENTA: 0,
            RETEIVA: 0,
            RETEICA: 0,
            RETEOTROS: 0,
            VENDEDOR_SELECTED: "",
            OBSERVACION_FACTURA: "",
            FACTURA_ASOCIADA: "",
            SHOW_DETAIL: false,
            data_items: [],
            detalle_recibos: [],
            data_cliente: [],
            totales: {
                TOTAL_BRUTO: 0,
                RETENCION: 0,
                TOTAL_IVA: 0,
                SUBTOTAL: 0,
                TOTAL_DESCUENTOS: 0,
                TOTAL_PAGAR: 0
            },
            show: false,
            showPress: false,
            mensajeImp: ""
        };
    }
    componentDidMount() {
        this.initFactura();
    }

    initFactura = () => {
        const inputName = document.getElementById("Nombre");
        if (inputName) inputName.value = "";
        const { currentUser } = this.state;
        const datasend = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'empresa': this.state.empresa,
                'currentUser': currentUser,
            }
        }
        fetch(config.servBackEnd + '/payment/', datasend).then(response => response.json())
            .then(data => {
                const cData = data.data;
                const clientes = cData[0];
                const metodo_pago = cData[1];
                this.setState({
                    clientes,
                    metodo_pago,
                    FORMA_PAGO: "",
                    CLIENTE: "",
                    SHOW_DETAIL: false,
                    OBSERVACION_FACTURA: ""
                });
                this.clearItem();
            });
    }

    changeValor = ({ target }, position) => {
        const newDetalle = this.state.detalle_recibos;
        let { value } = target;
        const { name } = target;
        value = (value || 0);
        newDetalle.forEach((element, index) => {
            if (position === index) {
                element[name] = value;
            };
        });
        this.setState({ detalle_recibos: newDetalle });
        this.calcTotales();
    }

    calcTotales = () => {
        const newDetalle = this.state.detalle_recibos;
        let RENTA = 0;
        let RETEIVA = 0;
        let RETEICA = 0;
        let RETEOTROS = 0;
        let TOTAL_BRUTO = 0;
        let RETENCION = 0;
        let TOTAL_IVA = 0;
        let SUBTOTAL = 0;
        let TOTAL_DESCUENTOS = 0;
        let TOTAL_PAGAR = 0;
        newDetalle.forEach(element => {
            /* element.TOTAL = Math.round(element.CANTIDAD * element.VALOR_UNI);
            element.VALOR_DCTO = Math.round(element.TOTAL * element.DESCUENTO / 100);
            element.VALOR_IVA = Math.round((element.TOTAL - element.VALOR_DCTO) * element.PORCENTAJE_IVA / 100);
            element.RENTA_DETALLE = Math.round((element.TOTAL - element.VALOR_DCTO) * element.PORCENTAJE_RETENCION / 100);

            RENTA += (element.RENTA_DETALLE) ? element.RENTA_DETALLE : 0;
            RETENCION += (element.RENTA_DETALLE) ? element.RENTA_DETALLE : 0;*/
            TOTAL_BRUTO += parseFloat(element.VALOR_PAGAR);
            TOTAL_DESCUENTOS += parseFloat(element.VALOR_DESCUENTO);
            TOTAL_PAGAR = TOTAL_BRUTO + TOTAL_DESCUENTOS;
            /*TOTAL_IVA += element.VALOR_IVA;
            TOTAL_PAGAR = TOTAL_BRUTO - TOTAL_DESCUENTOS + TOTAL_IVA; */
        });
        /* newDetalle.forEach(element => {
            if (element.BASE_MINIMA_VENTA > SUBTOTAL) {
                RENTA -= (element.RENTA_DETALLE) ? element.RENTA_DETALLE : 0;
                RETENCION -= (element.RENTA_DETALLE) ? element.RENTA_DETALLE : 0;
                element.RENTA_DETALLE = 0;
            }
        });
        if (data_cliente[0].LIQUIDA_RETEIVA) {
            retenciones.forEach(element => {
                if (element.TIPO_RETENCION === "2") {
                    RETEIVA += (element.BASE_MINIMA_VENTA <= SUBTOTAL) ? Math.round(TOTAL_IVA * element.PORCENTAJE_RETENCION / 100) : 0;
                    RETENCION += RETEIVA;
                }
            });
        }

        if (data_cliente[0].LIQUIDA_RETEICA) {
            retenciones.forEach(element => {
                if (element.TIPO_RETENCION === "3") {
                    RETEICA += (element.BASE_MINIMA_VENTA <= SUBTOTAL) ? Math.round(SUBTOTAL * element.PORCENTAJE_RETENCION / 100) : 0;
                    RETENCION += RETEICA;
                }
            });
        }

        if (data_cliente[0].LIQUIDA_RETEOTROS) {
            retenciones.forEach(element => {
                if (element.TIPO_RETENCION === "4") {
                    RETEOTROS += (element.BASE_MINIMA_VENTA <= SUBTOTAL) ? Math.round(SUBTOTAL * element.PORCENTAJE_RETENCION / 100) : 0;
                    RETENCION += RETEOTROS;
                }
            });
        }

        TOTAL_PAGAR -= RETENCION;
 */
        const newTotal = {
            TOTAL_BRUTO,
            RETENCION,
            TOTAL_IVA,
            SUBTOTAL,
            TOTAL_DESCUENTOS,
            TOTAL_PAGAR
        }

        this.setState({
            RENTA,
            RETEIVA,
            RETEICA,
            RETEOTROS,
            detalle_recibos: newDetalle,
            totales: newTotal
        })
    }

    removeitem = (index) => {
        let newData = this.state.detalle_recibos;

        newData.splice(index, 1);

        ////console.log(newData);
        this.setState({ detalle_recibos: newData });
        this.calcTotales();
    }

    selectCLient = (client) => {
        const SHOW_DETAIL = true;
        const data_cliente = []
        data_cliente.push(client);
        this.setState({
            SHOW_DETAIL,
            cliente: client,
            data_cliente,
            totales: {
                TOTAL_BRUTO: 0,
                RETENCION: 0,
                TOTAL_IVA: 0,
                SUBTOTAL: 0,
                TOTAL_DESCUENTOS: 0,
                TOTAL_PAGAR: 0
            },
            RENTA: 0,
            RETEIVA: 0,
            RETEICA: 0,
            RETEOTROS: 0,
            detalle_recibos: []
        });
    }

    clearItem = () => {
        this.setState({
            detalle_recibos: [],
            totales: {
                TOTAL_BRUTO: 0,
                RETENCION: 0,
                TOTAL_IVA: 0,
                SUBTOTAL: 0,
                TOTAL_DESCUENTOS: 0,
                TOTAL_PAGAR: 0
            },
            RENTA: 0,
            RETEIVA: 0,
            RETEICA: 0,
            RETEOTROS: 0
        })

    }

    saveInvoice = (event) => {
        event.preventDefault();
        const formDetail = document.getElementById("detailForm");
        if (formDetail.checkValidity()) {
            const { cliente } = this.state;
            const { totales } = this.state;
            //const { metodo_pago } = this.state;
            //const { vendedores } = this.state;
            //const { retenciones } = this.state;
            const { detalle_recibos } = this.state;

            const Cabecera = {
                ID_EMPRESA: this.state.empresa,
                TIPO_DOCUMENTO_RECIBO: 'RC',
                CLIENTE_CODIGO: cliente.DOCUMENTO_CLIENTE,
                ID_METODO_PAGO: this.state.FORMA_PAGO,
                TOTAL_VALOR: totales.TOTAL_BRUTO,
                TOTAL_DESCUENTO: totales.TOTAL_DESCUENTOS,
                OBSERVACION_PAGO: this.state.OBSERVACION_FACTURA
            }

            let Detalle = []

            detalle_recibos.forEach((element, index) => {
                Detalle.push(
                    {
                        ID_FACTURA: element.ID_FACTURA,
                        ID_EMPRESA: this.state.empresa,
                        TIPO_DOCUMENTO_RECIBO: 'RC',
                        TIPO_DOCUMENTO_FACTURA: element.TIPO_DOCUMENTO_CABECERA,
                        NUMERO_DOCUMENTO_FACTURA: element.NUMERO_FACTURA_CABECERA,
                        VALOR_ABONADO: element.VALOR_PAGAR,
                        VALOR_DESCUENTO: element.VALOR_DESCUENTO
                    }
                );
            });

            const reciboCaja = {
                Cabecera,
                Detalle
            }

            const datasend = {
                method: 'POST',
                body: JSON.stringify(reciboCaja),
                headers: {
                    'Content-Type': 'application/json',
                    'empresa': this.state.empresa,
                    'tipo': this.state.tipo,
                }
            };

            fetch(config.servBackEnd + '/payment/create', datasend).then(response => response.json())
                .then(data => {
                    if (data.ok) {
                        const { id } = data;
                        this.setState({ showAlert: true, numeroDocumento: data.DOCUMENTO_CREADO, show: false, showPress: true, id });
                        this.initFactura();
                    } else {
                        //console.log(data);
                    }
                });
        }

    }

    addFactura = (resultado) => {
        const { detalle_recibos } = this.state;
        let control = true;
        detalle_recibos.forEach(element => {
            if (element.ID_FACTURA === resultado.ID_FACTURA) control = false;
        });

        if (control) {
            resultado.VALOR_PAGAR = 0;
            resultado.VALOR_DESCUENTO = 0;
            detalle_recibos.push(resultado);
        }

        this.setState({
            detalle_recibos
        });
        this.calcTotales();

    }

    handleClose = () => {
        this.setState({ show: false });
    }

    confirmEnvio = (event) => {
        event.preventDefault();
        this.setState({ show: true });
    }

    hideModalImp = () => {
        this.setState({ showPress: false, mensajeImp: "" });
    }

    impresionPDF = () => {
        const { id } = this.state;
        const datasend = {
            method: 'GET',
            headers: {
                'Content-Type': 'blob',
                'empresa': this.state.empresa
            }
        }
        fetch(config.servBackEnd + '/payment/getpdf/' + id, datasend)
            .then((res) => {
                if (res.ok) return res.blob();
            }).then(function (myBlob) {
                var objectURL = URL.createObjectURL(myBlob);
                document.querySelector('#pdf-frame').src = '';
                document.querySelector('#pdf-frame').src = objectURL;
                objectURL = URL.revokeObjectURL(myBlob);
            }).then(
                function () {
                    window.setTimeout(function () {
                        document.querySelector('#pdf-frame').contentWindow.print();
                    }, 1000)
                })
            .catch((err) => {
                console.error(err);
            });
    }

    enviarCorreo = () => {
        const { id } = this.state;
        const datasend = {
            method: 'GET',
            headers: {
                'Content-Type': 'blob',
                'empresa': this.state.empresa
            }
        }
        fetch(config.servBackEnd + '/files/createsendpayment/' + id, datasend)
            .then(data => {
                this.setState({ mensajeImp: "Correo Enviado Correctamente" });
            });
    }

    render() {
        const { empresa } = this.state;
        const { data_cliente } = this.state;
        const { clientes } = this.state;
        const { metodo_pago } = this.state;
        const { detalle_recibos } = this.state;
        const { totales } = this.state;
        const { numeroDocumento } = this.state;
        const { showAlert } = this.state;
        const changeValor = this.changeValor;
        const removeitem = this.removeitem;
        const clearItem = this.clearItem;
        const saveInvoice = this.saveInvoice;
        const addFactura = this.addFactura;
        return (
            <div className="contenedor">
                <iframe id="pdf-frame"></iframe>

                <Jumbotron className="Jumbotron">
                    <h1>Modulo Recibos Caja</h1>
                </Jumbotron>
                {showAlert &&
                    <Alert variant='success'>
                        El documento No {numeroDocumento}  se creo satisfactoriamente.
                    </Alert>
                }
                <Form onSubmit={this.confirmEnvio}>
                    <Form.Row>
                        <Form.Group as={Col}>
                            <Form.Label>CLIENTE</Form.Label>
                            <SearchClient data={clientes} event={this.selectCLient} ></SearchClient>
                        </Form.Group>
                        <Form.Group as={Col} controlId="">
                            <Form.Label>METODO DE PAGO</Form.Label>
                            <Form.Control as="select" onChange={(e) => this.setState({ FORMA_PAGO: e.target.value })} value={this.state.FORMA_PAGO} required >
                                <option value="">Seleccione</option>
                                {metodo_pago.map(function (currentData, index) {
                                    return <option key={'p' + index} value={currentData.ID_METODO_PAGO}>{currentData.DESCRIPCION_METODO_PAGO}</option>;
                                })}
                            </Form.Control>
                        </Form.Group>
                    </Form.Row>
                    <Form.Row>
                        <Form.Group as={Col}>
                            <Form.Label>OBSERVACIONES</Form.Label>
                            <Form.Control as="textarea" rows="1" onChange={(e) => this.setState({ OBSERVACION_FACTURA: e.target.value.toUpperCase() })} value={this.state.OBSERVACION_FACTURA} />
                        </Form.Group>
                    </Form.Row>
                    {this.state.SHOW_DETAIL &&
                        <div>
                            <Modalfactura showfilter={false} estado="0" empresa={empresa} cliente={data_cliente} callback={addFactura} />
                            <Button className="m-2" type="submit" disabled={detalle_recibos.length === 0}>Guardar</Button>
                            <Button className="m-2" onClick={clearItem} disabled={detalle_recibos.length === 0} >Limpiar</Button>
                        </div>
                    }
                </Form>
                {this.state.SHOW_DETAIL &&
                    <div>
                        <Row>
                            <Col>
                                <Form id="detailForm">
                                    <Table striped bordered hover>

                                        <thead>
                                            <tr>
                                                {/* <th>CODIGO</th> */}
                                                <th></th>
                                                <th>DOCUMENTO</th>
                                                <th>FECHA CADUCIDAD</th>
                                                <th>TOTAL</th>
                                                <th>ABONADO</th>
                                                <th>PENDIENTE</th>
                                                <th>ABONO</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {detalle_recibos.map(function (element, index) {
                                                return <tr key={'tr' + index}>
                                                    <td>
                                                        <IconContext.Provider value={{ size: "2em" }}>
                                                            <IoIosRemoveCircle onClick={() => removeitem(index)} />
                                                        </IconContext.Provider>
                                                    </td>
                                                    <td> {element.TIPO_DOCUMENTO_CABECERA + "-" + element.NUMERO_FACTURA_CABECERA} </td>
                                                    <td> {funciones.formatDate(element.FECHA_VENCIMIENTO_DOCUMENTO)}</td>
                                                    <td> {element.TOTAL_VENTA}</td>
                                                    <td> {element.TOTAL_ABONADO}</td>
                                                    <td> {parseFloat(element.TOTAL_VENTA) - parseFloat(element.TOTAL_ABONADO)}</td>
                                                    <td> <input name="VALOR_PAGAR" max={parseFloat(element.TOTAL_VENTA) - parseFloat(element.TOTAL_ABONADO)} type="number" onChange={(e) => changeValor(e, index)} required /></td>
                                                    {/* <td> <input name="VALOR_DESCUENTO" max={parseFloat(element.TOTAL_VENTA) - parseFloat(element.TOTAL_ABONADO) - parseFloat(element.VALOR_PAGAR)} type="number" onChange={(e) => changeValor(e, index)} /></td> */}
                                                </tr>
                                            })}
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <td colSpan="5"></td>
                                                <td>TOTAL ABONADO</td>
                                                <td>{totales.TOTAL_PAGAR}</td>
                                            </tr>
                                        </tfoot>

                                    </Table>
                                </Form>
                            </Col>
                        </Row>
                    </div>
                }
                <ModalConfirm show={this.state.show} enviarInfo={saveInvoice} handleClose={this.handleClose} mensaje="Seguro desea guardar Recibo de caja?" ></ModalConfirm>
                <ModalImpresion hideModalImp={this.hideModalImp} impresionPDF={this.impresionPDF} enviarCorreo={this.enviarCorreo} showPress={this.state.showPress} mensaje={this.state.mensajeImp}></ModalImpresion>
            </div>
        );
    }
}
export default (Facturas);



// WEBPACK FOOTER //
// ./src/components/bussines/cartera/recibosCaja.jsx